import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stubTrue } from 'lodash/fp';

// Actions
import { openPopup } from '../../../../../components/popupPanel/popupActions';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

// Selectors
import { getShouldShowLocaleSuggestionPopup } from './localeSuggestionSelector';
import { loadLanguage } from '../../../../../i18n/initI18n';

const LocaleSuggestionManager = () => {
    const dispatch = useDispatch();
    const shouldShowLocaleSuggestion = useSelector(getShouldShowLocaleSuggestionPopup);
    const hasOpenedRef = useRef(false);

    useEffect(() => {
        if (!shouldShowLocaleSuggestion || hasOpenedRef.current) return;

        hasOpenedRef.current = true;

        const preloadAndOpen = async () => {
            try {
                await loadLanguage('es');
            } catch {
                // If preloading fails, still attempt to open the popup
            }

            dispatch(openPopup({ popupId: PopupIds.LOCALE_SUGGESTION, predicateFn: stubTrue }));
        };

        preloadAndOpen();
    }, [dispatch, shouldShowLocaleSuggestion]);

    return null;
};

export default LocaleSuggestionManager;
